import styled from '@emotion/styled'
import { Box, Container, Stack, Typography } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import { customStyles } from '../../styles'
import { NextBackButtons } from '../helpers/buttons/NextBackButtons'

const CustomContainer = styled(Container)(() => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  height: '70vh',
}))

export const PageContainer = ({ children }) => {
  const navigate = useNavigate()
   const [ token, setValue ] = useLocalStorage('login-token', null)

   useEffect(() => {
      !token && navigate('/')
    }, [])

  return (
    <>
      {
        token &&
        <CustomContainer  sx={{ padding: 0 }}>
            <Box width={ customStyles.containers.large }>
            { children }
            </Box>
        </CustomContainer>
      }
    </>
  )
}
